import { render, staticRenderFns } from "./paymentSon.vue?vue&type=template&id=8a1030dc&scoped=true"
import script from "./paymentSon.vue?vue&type=script&lang=js"
export * from "./paymentSon.vue?vue&type=script&lang=js"
import style0 from "./paymentSon.vue?vue&type=style&index=0&id=8a1030dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a1030dc",
  null
  
)

export default component.exports